// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"b65590cf","214":"dd38b1ca","307":"2c40de3a","521":"bb95afa1","638":"2987cd34","715":"8f2e0047"}[chunkId] + ".chunk.js";
};